// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nO-e","footer":"styles_footer__bMKA8"};